import React from 'react';
import { AlertTriangle } from "react-feather";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';



export const DeleteSeller = ({ closeModalSeller, loading, name, saveDelete, arraySeller, loadingSeller }) => {


    // * STYLES DATA TABLE
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "10px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };

    // * CONFIGURACION DE LOS DATOS 

    return (
        <div>
            {
                arraySeller.length > 0 ? <div className="pt-3">
                    <div
                        style={{
                            background: "#fff4e5",
                            border: "1px solid #ffcc80",
                            borderLeft: "6px solid #ff9800",
                            borderRadius: "12px",
                            padding: "13px",
                            marginBottom: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >
                        <i
                            className="pi pi-exclamation-triangle"
                            style={{
                                fontSize: "2rem",
                                color: "#ff9800"
                            }}
                        />
                        <div>
                            <div
                                style={{
                                    fontSize: "13px",
                                    fontWeight: "700",
                                    color: "#e65100",
                                    marginBottom: "4px"
                                }}
                            >
                                Eliminación bloqueada
                            </div>

                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#6b7280"
                                }}
                            >
                                Este vendedor tiene&nbsp;
                                <strong> convenios vigentes asignados</strong>.
                                Para continuar, primero debes reasignar o finalizar los convenios relacionados.
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "12px"
                        }}
                    >
                        <div
                            style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "#0d3b59"
                            }}
                        >
                            Convenios asociados
                        </div>

                        <div
                            style={{
                                background: "#fff3cd",
                                color: "#856404",
                                padding: "5px 12px",
                                borderRadius: "20px",
                                fontSize: "10px",
                                fontWeight: "600"
                            }}
                        >
                            {arraySeller.length} convenio(s)
                        </div>
                    </div>
                    {
                        // * DATATABLE SELLER
                    }
                    <DataTable
                        value={arraySeller}
                        responsiveLayout="scroll"
                        className="p-datatable-sm"
                        paginator
                        rows={7}
                        rowsPerPageOptions={[7, 20, 30, 40, 50]}
                        emptyMessage="No existen convenios asociados."
                        stripedRows
                    >
                        <Column
                            header="#"
                            body={(rowData, { rowIndex }) => rowIndex + 1}
                            headerStyle={headerStyle}
                            style={centerStyle}
                            sortable
                        />

                        <Column
                            field="nameAgreement"
                            header="No. de Contrato / Nombre"
                            body={(row) => (
                                <span
                                    style={{
                                        fontWeight: "500",
                                        color: "#374151"
                                    }}
                                >
                                    {row.nameAgreement}
                                </span>
                            )}
                            headerStyle={headerStyle}
                            style={centerStyle}
                            sortable
                        />

                        <Column
                            field="name_company"
                            header="Empresa / Cliente"
                            body={(row) => (
                                <span
                                    style={{
                                        color: "#4b5563"
                                    }}
                                >
                                    {row.name_company}
                                </span>
                            )}
                            headerStyle={headerStyle}
                            style={centerStyle}
                            sortable
                        />
                    </DataTable>
                </div>
                    :
                    <div className='pt-3' >
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                            marginBottom: "15px"
                        }}>
                            <div style={{
                                backgroundColor: "#ffe6e6",
                                borderRadius: "50%",
                                width: "80px",
                                height: "48px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <AlertTriangle size={28} color="#c92a2a" />
                            </div>

                            <div>
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: "13px",
                                        color: "#0d3b59"
                                    }}
                                >
                                    Esta acción no se puede deshacer. ¿Estás seguro de eliminar al vendedor?
                                </p>
                            </div>
                        </div>

                        <div style={{
                            background: "#f8fbff",
                            padding: "12px 14px",
                            borderRadius: "8px",
                            border: "1px solid #d7e7f5"
                        }}>
                            <span style={{ fontWeight: 500, color: "#0d3b59" }}>
                                {name}
                            </span>
                        </div>
                    </div>
            }
        </div>
    )
}
